import {Box, Slider, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const CompareFade = ({value, onChange}) => {
  const {t} = useTranslation();

  const handleOnChange = (_, value) => {
    onChange(value);
  };

  return (
    <Box
      data-qe="compare-fade-slider"
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">{t('common:opacity', 'Opacity')}</Typography>
      <Slider
        size="small"
        sx={{
          ml: 3,
          mb: 0.5,
          minWidth: 200,
        }}
        max={1}
        min={0}
        onChange={handleOnChange}
        step={1 / 100}
        values={value}
        marks={[
          {value: 0, label: '0%'},
          {value: 1, label: '100%'},
        ]}
        valueLabelDisplay="auto"
        valueLabelFormat={val => `${Math.round(val * 100)}%`}
      />
    </Box>
  );
};

CompareFade.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
};

export default CompareFade;
